var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h2',[_vm._v("Logged Out successfully")]),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Login")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }